module.exports = __webpack_public_path__ + "assets/slike/tenkovi/nemacki-tenk-cev.be95abcc860d72d85f06929eb8378c7f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/slike/tenkovi/nemacki-tenk-cev.png
// module id = 38
// module chunks = 0